module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp123_4.0bced5c4.png";